export default __webpack_public_path__ + "static/media/waterActiveIcon.57ddb115.svg";